/* import __COLOCATED_TEMPLATE__ from './application.hbs'; */
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import ENV from 'register-partners-js/config/environment';

import styles from './application.module.css';

export default class ApplicationLayout extends Component {
  styles = styles;

  @service cookiesConsentManager;
  @service metricsManager;

  didomi = ENV.didomi;

  @action onCookieConsentReady() {
    if (!this.cookiesConsentManager.shouldConsentBeCollected()) {
      this.metricsManager.activateMetricsAdapters();
    }
  }

  @action onCookieConsentUpdated() {
    this.metricsManager.activateMetricsAdapters();
  }
}
